export default (id: string): string => id.split('-')[0]
